module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_arrow_bottom_gold-0a06d599e6a94276df4b7da39d29a300.svg";